// src/pages/analytics/AnalyticsPage.jsx
import React from 'react';

const AnalyticsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Analytics Page</h1>
        <p className="text-gray-600">Coming soon...</p>
      </div>
    </div>
  );
};

export default AnalyticsPage;